export const SET_HAS_AVAILABLE_DEVICE = "SET_HAS_AVAILABLE_DEVICE";
export const SET_IS_PLAYING = "SET_IS_PLAYING";
export const SET_IS_PLAYING_CAST = "SET_IS_PLAYING_CAST";
export const SET_VIDEO_DETAILS = "SET_VIDEO_DETAILS";
export const SET_PLAYING_VIDEO_DETAILS = "SET_PLAYING_VIDEO_DETAILS";
export const SET_AIRPLAY_AVAILABILITY = "SET_AIRPLAY_AVAILABILITY";
export const SET_AIRPLAY_CONNECTIVITY = "SET_AIRPLAY_CONNECTIVITY";
export const SET_CAST_AVAILABILITY = "SET_CAST_AVAILABILITY";
